import PropTypes from "prop-types"
import { Fragment, Suspense } from "react"

import Expand from "components/ui/expand"
import { to_currency } from "helpers/number"
import { hasHebrewChar } from "helpers/product/text-dir"
import { cn } from "styles/utils"

const Detail = ({ className = "", ...props }) => (
  <p className={cn("text-12 mb-2 font-medium", className)} {...props} />
)

const ItemDetails = ({ details, id, showDetails }) => (
  <>
    {typeof window !== "undefined" && (
      <Suspense fallback={<div />}>
        <Expand id={id} show={showDetails}>
          <div className="tablet:pt-4 tablet:pb-0 pl-15 tablet:pl-0 pb-20">
            <Details details={details} />
          </div>
        </Expand>
      </Suspense>
    )}
  </>
)

export const Details = ({ details }) => {
  return (
    <>
      {typeof window !== "undefined" && (
        <Suspense fallback={<div />}>
          {details.map((detail) => (
            <Fragment key={`itemDetails-${detail.name}`}>
              {detail.values ? (
                <>
                  <Detail>{!!detail.label && `${detail.label}: `}</Detail>
                  {detail.values.map((value) => (
                    <Detail key={value}>- {value}</Detail>
                  ))}
                </>
              ) : (
                <Detail>
                  {!!detail.label && `${detail.label}: `}
                  <span
                    className="[&_a]:text-primary [&_a]:underline"
                    dangerouslySetInnerHTML={{ __html: detail.value }}
                    {...(hasHebrewChar(detail.value) ? { dir: "auto" } : {})}
                  />
                  {detail.price !== 0 && detail.name === "de" && (
                    <span> ({to_currency(detail.price)})</span>
                  )}
                  {detail.price !== 0 && detail.name !== "de" && (
                    <span> (+{to_currency(detail.price)})</span>
                  )}
                </Detail>
              )}
            </Fragment>
          ))}
        </Suspense>
      )}
    </>
  )
}

Details.propTypes = {
  details: PropTypes.array,
}

ItemDetails.propTypes = {
  details: PropTypes.array,
  id: PropTypes.string,
  showDetails: PropTypes.bool,
}
Detail.propTypes = {
  className: PropTypes.string,
}
export default ItemDetails
